import { useState } from 'react'
import RecruiterModeContext from './recruiterModeContext'

const isRecruiterModeUrl = () => {
	if (typeof window === 'undefined') return false

	const params = new URLSearchParams(window.location.search)
	return window.location.pathname === '/recruiter' || params.get('recruiter') === 'true' || params.get('mode') === 'recruiter'
}

const RecruiterModeState = (props) => {
	const [recruiterMode, setRecruiterMode] = useState(isRecruiterModeUrl)

	return (
		<RecruiterModeContext.Provider value={{ recruiterMode, setRecruiterMode }}>
			{props.children}
		</RecruiterModeContext.Provider>
	)
}

export default RecruiterModeState
